// Example zustand slice. One feature per file under src/store/; compose
// the public surface from src/store/index.ts. Slices stay focused — keep
// each one to one feature's state + the actions that mutate it.
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AuthUser = {
	id: string;
	name: string;
};

type AuthState = {
	user: AuthUser | null;
	signIn: (user: AuthUser) => void;
	signOut: () => void;
};

export const useAuth = create<AuthState>()(
	persist(
		(set) => ({
			user: null,
			signIn: (user) => set({ user }),
			signOut: () => set({ user: null }),
		}),
		{ name: "auth" },
	),
);
